import { Button, Empty, EmptyContent, EmptyDescription, EmptyHeader } from '@monksflow/monks-ui';
import { EmptyStateTitle } from '@/shared/ui';
import { useTranslation } from 'react-i18next';

interface BriefTemplatesErrorStateProps {
  /** Fires when the user clicks "Retry". Wired by the parent to `query.refetch()`. */
  onRetry: () => void;
}

/**
 * Error state for the Brief Templates list view.
 *
 * Rendered by `BriefTemplatesList` when the templates query errors and
 * there is no previous data to fall back on.
 *
 * Pure presentational. `role="alert"` so screen readers announce the
 * failure immediately.
 */
export function BriefTemplatesErrorState(props: BriefTemplatesErrorStateProps) {
  const { t } = useTranslation('knowledge');

  return (
    <Empty role="alert" data-testid="brief-templates-error-state" className="flex-1">
      <EmptyHeader>
        <EmptyStateTitle>
          {t('knowledgeHub.briefTemplatesErrorState.couldnTLoadBriefTemplates')}
        </EmptyStateTitle>
        <EmptyDescription>
          {t('knowledgeHub.briefTemplatesErrorState.somethingWentWrongPleaseTry')}
        </EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <Button variant="outline" size="default" onClick={props.onRetry}>
          {t('knowledgeHub.briefTemplatesErrorState.retry')}
        </Button>
      </EmptyContent>
    </Empty>
  );
}
